import { registerBlockType } from '@wordpress/blocks';
import './Style.jsx';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import icon from './icon.js';

import Icon from './index.jsx';


window.Icon = Icon;

registerBlockType( metadata.name, {
	edit: Edit,
	save,
	icon,
} );
